import get from 'lodash-es/get'
import * as React from 'react'

import experimentsConfig from '../../../../common/constants/experiments'
import { getFlattenLocation } from '../../../../common/utils/urlHelper'
import createAutoSuggestDataContainer from '../../../shared/components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../../shared/components/autosuggest/autoSuggestLogicContainer'
import HostedHeader from '../../../shared/components/hostedHeader'
import SearchPageContentWrapper from '../../../shared/components/searchPageContentWrapper'
import SearchResultHeaders from '../../../shared/components/searchResultHeaders'
import AutoSuggest from '../../components/autosuggest/autosuggest'
import SearchHeader from '../../components/searchHeader'
import SearchPageArticle from './content/searchPageArticle'
import SearchPageRelatedPosts from './content/searchPageRelatedPosts'
import SearchContentSection from './searchContentSection'

import * as autoSuggestStyles from '../../components/autosuggest/themes/searchpage.module.css'
import searchResultHeadersStyles from '../../components/searchHeader/themes/resultHeadersDefault'
import * as searchHeaderStyles from '../../components/searchHeader/themes/searchpage.module.css'
import * as styles from './searchPage.module.css'

import GraphicRiverEaseOfUseSurvey from '../../../shared/components/surveyBanners/graphicRiverEaseOfUseSurvey'

import { Props } from '../../../shared/containers/searchPageContainer'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

class SearchPage extends React.Component<Props> {
  public componentDidUpdate(prevProps: Props) {
    const { locationParams, onSearchPageDidUpdate } = this.props
    onSearchPageDidUpdate(
      locationParams,
      prevProps.userHasLoadAttempt,
      prevProps.results
    )
  }

  public render() {
    const {
      userHasLoadAttempt,
      searchResultsViewType,
      location,
      results,
      loading,
      searchHeadings,
      ingestedContent,
      currentSite,
      baseUrl,
      relatedSearches,
      studioRecommendations,
      push,
      openModal,
      experimentsReady,
      locationParams,
      makeSearchLink
    } = this.props

    const didYouMeanByTerms = get(results, 'suggestions')
    const authorSuggestion = get(results, 'matching_author')
    const flattenLocation = getFlattenLocation(location)
    const seoMeta = {
      heading: searchHeadings.heading,
      subHeading: searchHeadings.sub_heading
    }

    const hostingSetupSelected = locationParams.hosting_setup === '1'

    return (
      <SearchPageContentWrapper experimentsReady={experimentsReady}>
        <div className="canvas_body">
          {hostingSetupSelected ? (
            <HostedHeader wide={false} openModal={openModal}>
              <AutoSuggestContainer
                inputName="term"
                value={locationParams.term}
                placeholder="Search within these results"
                currentSite={currentSite}
                locationParams={locationParams}
                makeSearchLink={makeSearchLink}
                styles={autoSuggestStyles}
              />
              <SearchResultHeaders
                locationParams={locationParams}
                totalHits={results.total_hits}
                didYouMeanByTerms={didYouMeanByTerms}
                authorSuggestion={authorSuggestion}
                seoMeta={seoMeta}
                styles={searchResultHeadersStyles}
                TagName="h1"
              />
            </HostedHeader>
          ) : (
            <div className={styles.searchHeaderSection}>
              <SearchHeader
                currentSite={currentSite}
                styles={searchHeaderStyles}
              >
                <AutoSuggestContainer
                  inputName="term"
                  value={locationParams.term}
                  placeholder="Search within these results"
                  currentSite={currentSite}
                  locationParams={locationParams}
                  makeSearchLink={makeSearchLink}
                  styles={autoSuggestStyles}
                />
                <SearchResultHeaders
                  locationParams={locationParams}
                  totalHits={results.total_hits}
                  didYouMeanByTerms={didYouMeanByTerms}
                  authorSuggestion={authorSuggestion}
                  seoMeta={seoMeta}
                  styles={searchResultHeadersStyles}
                  TagName="h1"
                />
              </SearchHeader>
            </div>
          )}
          <div className={styles.surveyContainer}>
            <GraphicRiverEaseOfUseSurvey currentSite={currentSite} />
          </div>
          <div className="content-main--basic">
            <div className="faceted-search">
              <SearchContentSection
                push={push}
                searchResultsViewType={searchResultsViewType}
                baseUrl={baseUrl}
                results={results}
                location={location}
                loading={loading}
                currentSite={currentSite}
                relatedSearches={relatedSearches}
                studioRecommendations={studioRecommendations}
                locationParams={locationParams}
                makeSearchLink={makeSearchLink}
              />
            </div>

            {ingestedContent && (
              <div className="search-page-content">
                {!!ingestedContent.article && (
                  <SearchPageArticle html={ingestedContent.article} />
                )}
                {ingestedContent.related_posts &&
                  ingestedContent.related_posts.length === 3 && (
                    <SearchPageRelatedPosts
                      posts={ingestedContent.related_posts}
                    />
                  )}
              </div>
            )}
          </div>
        </div>
      </SearchPageContentWrapper>
    )
  }
}

export default SearchPage
